import Select from "react-select";
import { SearchFieldStyles } from "../Searchfields/SearchFieldStyles";

const options = [
    { value: 1, label:  "Não se aplica" },
    { value: 2, label:  "75 kVA" },
    { value: 3, label:  "112,5 kVA" },
    { value: 4, label:  "225,5 kVA" },
    { value: 5, label:  "Outro" }
];

const TransformadorParticular = ({ field, placeholder, name, id, disabled=false, onKeyDown, className="" }) => {
    return (
        <Select 
            options={options}
            {...field}
            styles={SearchFieldStyles}
            placeholder={placeholder}
            name={name}
            isDisabled={disabled}
            id={id}
            onKeyDown={onKeyDown}
            className={className}
        />
    )
}

export { TransformadorParticular, options as OpcoesTransformadorParticular }